module.exports = __webpack_public_path__ + "img/collectivibe-logo-grayscale.556130f6.png";